import { DataExtender } from '../../../Foundation/Base/Pipelines/DataExtending/DataExtender'
import { DataExtenderResponse } from '../../../Foundation/Base/Pipelines/DataExtending/DataExtenderResponse'
import { GetAuctionPagePropertiesType } from '../../../Foundation/Auctions/serviceRegistration'
import { LotService } from '../../../Foundation/LotApi/Services/LotService'
import { DataExtenderRequest } from '../../../Foundation/Base/Pipelines/DataExtending/DataExtenderRequest'

export class LotPageDataExtender implements DataExtender {
  constructor(private lotService: LotService, private getAuctionPageProperties: GetAuctionPagePropertiesType) {}

  async process(request: DataExtenderRequest): Promise<DataExtenderResponse> {
    const serviceResult = await this.lotService.getLotFromHttpRequest(request)

    const propertiesResult = await this.getAuctionPageProperties({
      language: request.sitecore.context.language as string,
      saleId: serviceResult.sale.sale_id,
      saleNumber: serviceResult.sale.sale_number,
      saleRoomCode: serviceResult.sale.sale_room_code,
    })

    return {
      data: {
        lot: {
          apiResult: serviceResult,
          viewScaleEnabled: propertiesResult.view_scale_enabled,
        },
      },
    }
  }
}

//  DO NOT DELETE - used by DW
